import { Text, Link, ArrowRightIcon } from '@cash-me/react-components'

import { ItemType } from 'modules/help'
import { buildSimulatorUrl } from 'utils/buildSimulatorUrl'
import { pushDataLayer } from 'utils/push-data-layer'

import * as S from './styles'

const handleClick = (clickTarget: string, label: string) => {
  pushDataLayer({
    category: 'Clique',
    action: 'Botões',
    label: `${clickTarget} - Empréstimo Online - ${label}`
  })

  location.href = buildSimulatorUrl('/emprestimo-online/', { medium: clickTarget + '-' + label })
}

export const accordion = [
  {
    id: 'faq-0',
    title: 'Como fazer um pedido de Empréstimo Online na CashMe?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `Para fazer um pedido de Empréstimo Online com garantia de imóvel pelo site da CashMe, 
        basta preencher o formulário de simulação com os seguintes tópicos:`
      },
      {
        id: '2',
        type: 'node' as ItemType,
        content: (
          <>
            <S.List>
              <li>Escolha o valor desejado (acima de R$50 mil), o valor do seu imóvel e o número de parcelas;</li>
              <li>Informe seus dados pessoais;</li>
              <li>Informe os dados do imóvel que quer colocar em garantia;</li>
              <li>Conte para a gente qual é o seu objetivo com o empréstimo.</li>
            </S.List>
          </>
        )
      },
      {
        id: '3',
        type: 'link' as ItemType,
        content: {
          label: 'Simule agora',
          dataLayer: {
            category: 'Clique',
            action: 'Botões',
            label: 'Accordeon Pergunta: Como fazer um pedido de Empréstimo Online na CashMe? - Simule agora'
          },
          href: 'simulador-home-equity',
          icon: ArrowRightIcon
        }
      }
    ]
  },
  {
    id: 'faq-1',
    title: 'Qual é a taxa de juros?',
    item: [
      {
        id: '1',
        type: 'node' as ItemType,
        content: (
          <>
            <Text size="body2" color="var(--colors-neutral-text-weak)">
              Na CashMe, oferecemos opções pré e pós-fixadas. Para saber mais, entre em contato com a gente{' '}
              <Link onClick={() => handleClick('Qual é a taxa de juros?', 'aqui')} size="default">
                <Text as="span" size="body2" color="var(--colors-blue-text-default)">
                  aqui.
                </Text>
              </Link>
            </Text>
          </>
        )
      }
    ]
  },
  {
    id: 'faq-2',
    title: 'Quais os custos do Empréstimo Online?',
    item: [
      {
        id: '1',
        type: 'node' as ItemType,
        content: (
          <>
            <Text size="body2" color="var(--colors-neutral-text-weak)">
              As condições estão sujeitas à análise. Entre em contato com a gente{' '}
              <Link onClick={() => handleClick('Quais os custos do Empréstimo Online?', 'aqui')} size="default">
                <Text as="span" size="body2" color="var(--colors-blue-text-default)">
                  aqui.
                </Text>
              </Link>
            </Text>
            <Text size="body2" color="var(--colors-neutral-text-weak)">
              <b>Atenção:</b> a CashMe não cobra depósito, taxa de avalista, taxa para negativado ou qualquer outro tipo
              de pagamento antecipado.
            </Text>
          </>
        )
      }
    ]
  },
  {
    id: 'faq-3',
    title: 'Como o imóvel é colocado em garantia?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `O imóvel é colocado em garantia por meio de uma alienação fiduciária, na qual o cliente 
        continua usando o bem normalmente, mas o imóvel fica vinculado à propriedade do credor.`
      }
    ]
  },
  {
    id: 'faq-4',
    title: 'Meu score influencia a aprovação do meu crédito pessoal?',
    item: [
      {
        id: '1',
        type: 'text' as ItemType,
        content: `Sim, mas isso também não é tudo. Um bom score dá mais segurança às instituições 
        financeiras na hora de fazer a análise e ceder ou não o dinheiro. Porém, outros fatores 
        também influenciam no empréstimo, como o valor de seus bens, renda fixa etc.`
      }
    ]
  }
]
